export const LOAD_UNITS = '[unit] load units';
export const LOAD_UNIT = '[unit] load unit';
export const LOAD_ARCHIVE_UNITS = '[unit] load units archive';
export const ADD_UNIT = '[unit] add unit';
export const EDIT_UNIT = '[units] edit unit';
export const REMOVE_UNIT = '[unit] remove unit';
export const ARCHIVE_UNIT = '[unit] archive unit';
export const UNARCHIVE_UNIT = '[unit] unarchive unit';
export const PROCESS_UNIT = '[unit] process unit';
export const PROCESS_EDIT_UNIT = '[unit] process editing a unit';
export const PROCESS_ARCHIVE_UNIT = '[unit] process archiving unit';
export const PROCESS_UNARCHIVE_UNIT = '[unit] process unarchiving unit';
export const PROCESS_NEW_UNIT = '[unit] process new unit';
export const PROCESS_UNITS = '[unit] process units';
export const INSERT_UNIT = '[unit] insert unit';
export const UNIT_ERROR = '[unit] unit error';
export const UNITS_LOAD_ERROR = '[unit] units load error';
export const UNIT_LOAD_ERROR = '[unit] unit load error';
export const UNIT_ADD_ERROR = '[unit] unit add error';
export const UNIT_EDIT_ERROR = '[unit] unit edit error';
export const UNIT_ARCHIVE_ERROR = '[unit] unit archive error';
export const BULK_ASSOCIATE_PARENT_UNIT = '[unit] bulk associate parent unit';
export const LOAD_PROCESSED_UNITS = '[unit] load processed units';
export const IMPORT_UNITS = '[unit] import units csv';
export const CONFIRM_IMPORT_UNITS = '[unit] confirm import units csv';
export const UNITS_IMPORT_ERROR = '[unit] import units csv error';
export const EXPORT_UNITS = '[user] export units csv';
export const PROCESS_EXPORT_UNITS = '[user] process export units csv';
export const SET_LAST_UNITS_CHECKED = '[user] Set when units was checked';

export const addUnit = (unit, navigate, previous) => ({
  type: ADD_UNIT,
  payload: unit,
  navigate: navigate,
  previous,
});

export const editUnit = (unit, navigate, previous) => ({
  type: EDIT_UNIT,
  payload: unit,
  navigate,
  previous,
});

export const archiveUnit = (unit, navigate) => ({
  type: ARCHIVE_UNIT,
  payload: unit,
  navigate: navigate,
});

export const unArchiveUnit = (unit, navigate) => ({
  type: UNARCHIVE_UNIT,
  payload: unit,
  navigate: navigate,
});

export const processArchiveUnit = () => ({
  type: PROCESS_ARCHIVE_UNIT,
});

export const removeUnit = (unit) => ({
  type: REMOVE_UNIT,
  payload: unit,
});

export const processUnit = () => ({
  type: PROCESS_UNIT,
});

export const processEditUnit = () => ({
  type: PROCESS_EDIT_UNIT,
});

export const processNewUnit = () => ({
  type: PROCESS_NEW_UNIT,
});

export const processUnits = () => ({
  type: PROCESS_UNITS,
});

export const loadUnits = (units) => ({
  type: LOAD_UNITS,
  payload: units,
});

export const loadUnit = (unit) => ({
  type: LOAD_UNIT,
  payload: unit,
});

export const loadArchiveUnits = (units) => ({
  type: LOAD_ARCHIVE_UNITS,
});

export const insertUnit = (unit) => ({
  type: INSERT_UNIT,
  payload: unit,
});

export const unitError = () => ({
  type: UNIT_ERROR,
});
export const unitLoadError = () => ({
  type: UNIT_LOAD_ERROR,
});
export const unitsLoadError = () => ({
  type: UNITS_LOAD_ERROR,
});

export const unitAddError = (error) => ({
  type: UNIT_ADD_ERROR,
  payload: error,
});

export const unitArchiveError = (error) => ({
  type: UNIT_ARCHIVE_ERROR,
  payload: error,
});
export const unitEditError = (error) => ({
  type: UNIT_EDIT_ERROR,
  payload: error,
});

export const loadProcessedUnits = (processedUnits, currentTime) => ({
  type: LOAD_PROCESSED_UNITS,
  payload: processedUnits,
  currentTime,
});

export const bulkAssociateParentUnit = (values, navigate, previous) => ({
  type: BULK_ASSOCIATE_PARENT_UNIT,
  payload: values,
  previous: previous,
  navigate: navigate,
});

export const importUnits = (data, navigate, previous) => ({
  type: IMPORT_UNITS,
  payload: data,
  navigate: navigate,
  previous,
});

export const confirmImportUnits = (data, navigate, previous) => ({
  type: CONFIRM_IMPORT_UNITS,
  payload: data,
  navigate: navigate,
  previous,
});
export const unitsImportError = (error) => ({
  type: UNITS_IMPORT_ERROR,
  payload: error,
});

export const exportUnits = (payload, navigate, previous) => ({
  type: EXPORT_UNITS,
  payload,
  navigate: navigate,
  previous,
});
export const processExportUnits = (data, navigate, previous) => ({
  type: PROCESS_EXPORT_UNITS,
  payload: data,
  navigate: navigate,
  previous,
});
export const setLastUnitsChecked = (payload) => ({
  type: SET_LAST_UNITS_CHECKED,
  payload,
});
